module.exports = __webpack_public_path__ + "img/idas.c40d1322.png";